import React from 'react';
import { Helmet } from 'react-helmet-async';
import './TermsofUse.css';

const TermsOfUse = () => {
    return (
        <div className="terms-of-use-container">
            <Helmet>
                <title>Terms of Use - Pharm-Rx</title>
                <meta name="description" content="Terms of Use for Pharm-Rx Chemical Corporation." />
            </Helmet>
            <div className='terms-of-use-wrapper'>
                <div className='terms-of-use-content'>
                    <h2 className="section-heading">Terms of Use</h2>
                    <p className='section-content'>
                        Welcome to Pharm-Rx Chemical Corporation ("we," "us," "our"). By using our website, you agree to comply with and be bound by the following terms and conditions of use ("Terms of Use"), which together with our privacy policy govern Pharm-Rx's relationship with you in relation to this website. If you disagree with any part of these terms and conditions, please do not use our website.
                    </p>
                    <h4 className="sub-section-heading">Use of the Website</h4>
                    <p className='section-content'>
                        The content of the pages of this website is for your general information and use only. It is subject to change without notice. Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness, or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.
                    </p>
                    <h4 className="sub-section-heading">Intellectual Property</h4>
                    <p className='section-content'>
                        This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance, and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.
                    </p>
                    <h4 className="sub-section-heading">Unauthorized Use</h4>
                    <p className='section-content'>
                        Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offense.
                    </p>
                    <h4 className="sub-section-heading">Links to Other Websites</h4>
                    <p className='section-content'>
                        From time to time, this website may also include links to other websites. These links are provided for your convenience to provide further information. They do not signify that we endorse the website(s). We have no responsibility for the content of the linked website(s).
                    </p>
                    <h4 className="sub-section-heading">Limitation of Liability</h4>
                    <p className='section-content'>
                        Your use of any information or materials on this website is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services, or information available through this website meet your specific requirements.
                    </p>
                    <h4 className="sub-section-heading">Governing Law</h4>
                    <p className='section-content'>
                        Your use of this website and any dispute arising out of such use of the website is subject to the laws of the United States and the state of New Jersey.
                    </p>
                    <h4 className="sub-section-heading">Contact Information</h4>
                    <p className='section-content'>
                        If you have any questions about these Terms of Use, please contact us at:
                    </p>
                    <p className='section-content'>
                        Pharm-Rx Chemical Corporation<br />
                        299 Market Street, Suite 410<br />
                        Saddle Brook, NJ 07663<br />
                        United States of America<br />
                        Telephone: (973) 917-1400<br />
                        Fax: (973) 917-1440
                    </p>
                </div>
            </div>
        </div>
    );
}

export default TermsOfUse;
